import { Body02, Checkbox, CheckboxState } from 'Components/designSystem';
import React from 'react';
import styled from 'styled-components';

interface ShiftScheduleListItemProps {
    dateStr: string;
    startTzStr: string | null;
    finishTzStr: string | null;
    onCheckboxClick: () => void;
    checked: boolean;
}

export default function ShiftScheduleListItem({ dateStr, startTzStr, finishTzStr, onCheckboxClick, checked }: ShiftScheduleListItemProps) {
    return (
        <Root>
            <Checkbox
                state={ checked ? CheckboxState.Checked : CheckboxState.NotChecked }
                onChange={ onCheckboxClick }
                label={ 
                    <Label>
                        <DateContainer>
                            <Body02>{ dateStr }</Body02>
                        </DateContainer>
                        <TimeCell startTzStr={ startTzStr }
                            finishTzStr={ finishTzStr }
                        />
                    </Label>

                }
            />
        </Root>
    );
}

function TimeCell({ startTzStr, finishTzStr }: {startTzStr: string | null; finishTzStr: string | null;}) {
    if (!finishTzStr || !startTzStr) {
        return null;
    }

    return (
        <TimeRangeContainer> 
            <Body02 >{ startTzStr }</Body02>
            &nbsp;–&nbsp;
            <Body02 color="secondary">{ finishTzStr }</Body02>
        </TimeRangeContainer>
    );
}

const Label = styled.div`
    display: flex;
    gap: ${ ({ theme }) => theme.size.size_30 };
    flex: 1;
    align-items: center;
`;

const Root = styled.div(({ theme }) => `
    padding: 6px 0;
    border-top: 1px solid ${ theme.semanticColor.divider };
`);


const DateContainer = styled.span`
    width: 30%;
`;

const TimeRangeContainer = styled.div`
    display: flex;
`;
